import { render } from "./BankDetails.vue?vue&type=template&id=3e2afd5d&ts=true"
import script from "./BankDetails.vue?vue&type=script&lang=ts"
export * from "./BankDetails.vue?vue&type=script&lang=ts"

import "./BankDetails.vue?vue&type=style&index=0&id=3e2afd5d&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/payment/BankDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e2afd5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e2afd5d', __exports__)) {
    api.reload('3e2afd5d', __exports__)
  }
  
  module.hot.accept("./BankDetails.vue?vue&type=template&id=3e2afd5d&ts=true", () => {
    api.rerender('3e2afd5d', render)
  })

}


export default __exports__